<template>
    <div class="col-12">
        <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="col-12 d-flex justify-content-center">
                <h2 class="">Criar uma nova categoria</h2>
            </div>
            <CategoryForm 
                v-model="category"
                :mode="'new'"
                @save="UpdateCategory"
            />
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import CategoryForm from './components/Form'

import Swal from 'sweetalert2'

export default {
    name: "NewCategory",
    components: {
        CategoryForm
    },
    data () {
        return {
            category: {
                descricao:          '',
                icone:              '',
                slug:               '',
            }
        }
    },
    computed: {
    },
    methods: {
        ...mapActions('system', [
            'StartLoading', 'FinishLoading', 'GetFaqItems'
        ]),
        async UpdateCategory(val)
        {
            this.category = val

            await this.SaveCategory()
        },
        async SaveCategory()
        {
            const vm = this

            vm.StartLoading()

            return await window.api.call('post', '/faq/save-category', {
                ...vm.category
            })
                .then(({data}) => {
                    if(data.response)
                    {
                        Swal.fire({
                            icon:       'success',
                            title:      'Categoria salvo com sucesso!',
                            toast:      true,
                            position:   'top',
                            timer:      4000,
                            timerProgressBar: true
                        })

                        vm.$router.push({ name: 'ManageCategories' })

                        return
                    }

                    Swal.fire({
                        icon:       'error',
                        title:      'Erro ao salvar a categoria.',
                        toast:      true,
                        position:   'top',
                        showConfirmButton: false,
                        timer:      3000,
                        timerProgressBar: true
                    })
                })
                .finally(() => {
                    vm.FinishLoading()
                })
        }
    },
    beforeMount() {

    }
    
}
</script>

<style>

</style>